// extracted by mini-css-extract-plugin
module.exports = {"similiarsTitle":"SimiliarResources_similiarsTitle__RyDZP"};